import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { RECORD_EVENT_REQUEST } from 'redux/analytics/constants';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listClubs, getClub, getClubItems, updateClubItems } from './api';
import {
  LIST_CLUBS_REQUEST,
  GET_CLUB_REQUEST,
  GET_CLUB_SUCCESS,
  CLUB_LIST_REQUESTING,
  CLUB_OBJECT_REQUESTING,
  LIST_CLUBS_SUCCESS,
  RESET_CLUB_ISFETCHING,
  GET_DYNAMIC_PRICING_CLUB_REQUEST,
  UPDATE_DYNAMIC_PRICING_CLUB_REQUEST
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_LIST_REQUESTING });
    const response = yield call(listClubs);

    yield put({ type: LIST_CLUBS_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubList',
      payload: response.data.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_OBJECT_REQUESTING });
    const response = yield call(getClub, action.slug);
    yield put({ type: GET_CLUB_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubDetail',
      payload: response.data
    });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
  return null;
}

export function* getDynamicClubPricing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_OBJECT_REQUESTING });
    const response = yield call(getClubItems, action.shipmentId);
    yield put({ type: GET_CLUB_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubDetail',
      payload: response.data
    });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
  return null;
}

export function* updatedDynamicClubPricing(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_OBJECT_REQUESTING });
    const response = yield call(
      updateClubItems,
      action.shipmentId,
      action.items
    );
    yield put({ type: GET_CLUB_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'clubDetail',
      payload: response.data
    });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_CLUB_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
  return null;
}

function* watchList() {
  yield takeLatest(LIST_CLUBS_REQUEST, list);
  yield takeEvery(GET_CLUB_REQUEST, get);
  yield takeEvery(GET_DYNAMIC_PRICING_CLUB_REQUEST, getDynamicClubPricing);
  yield takeEvery(
    UPDATE_DYNAMIC_PRICING_CLUB_REQUEST,
    updatedDynamicClubPricing
  );
}

export default function* clubSagas() {
  yield all([watchList()]);
}
